import React from 'react';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, Button, SxProps, Tooltip } from '@mui/material';

import { ConfirmTypes } from '@/components';
import { useAppDispatch } from '@/hooks';
import { showToast } from '@/store';

export interface CopyToClipboardBoxProps {
  text: string;
  sx?: SxProps;
  hideCopyButton?: boolean;
}

export const CopyToClipboardBox = ({
  text,
  sx,
  hideCopyButton = false,
}: CopyToClipboardBoxProps) => {
  const dispatch = useAppDispatch();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      dispatch(
        showToast({
          message: 'Text copied to clipboard',
          type: ConfirmTypes.SUCCESS,
        }),
      );
    } catch (err) {
      console.error('Failed to copy text: ', err);
      dispatch(
        showToast({
          message: 'Failed to copy text',
          type: ConfirmTypes.ERROR,
        }),
      );
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        border: '1px solid #E0E0E0',
        borderRadius: '8px',
        padding: '16px 0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#F8FAFC',
        ...sx,
      }}
      className="copy-box"
    >
      <Box sx={{ width: '100%', p: '8px 10px', mb: '2px' }}>{text}</Box>
      {!hideCopyButton && (
        <Tooltip title="Copy to clipboard">
          <Button onClick={handleCopy} sx={{ minWidth: '30px' }}>
            <ContentCopyIcon sx={{ height: '20px', color: '#216C17' }} />
          </Button>
        </Tooltip>
      )}
    </Box>
  );
};

export default CopyToClipboardBox;
